import { createFileRoute } from "@tanstack/react-router";
import type { BiologicalSex } from "@trainwell/features/clients";
import { useUserState } from "src/components/UserState";
import ProfileInput from "src/features/ProfileInput";

// Define the ProfileData type to match the one in ProfileInput
interface ProfileData {
  weightSystem: "metric" | "imperial";
  age: string;
  heightInches: string;
  weight: string;
  biologicalSex: BiologicalSex | undefined;
}

export const Route = createFileRoute("/_layout/profile")({
  component: RouteComponent,
});

function RouteComponent() {
  // Get profile from UserState
  const profile = useUserState((state) => state.profile);
  const setProfile = useUserState((state) => state.setProfile);

  const handleProfileChange = (newProfile: ProfileData | null) => {
    // If profile is null, clear the state
    if (newProfile === null) {
      setProfile(undefined);
      return;
    }

    // Check if the profile is valid (all fields filled)
    const isValid =
      newProfile.age !== "" &&
      newProfile.heightInches !== "" &&
      newProfile.weight !== "" &&
      newProfile.biologicalSex !== undefined;

    // Update the UserState
    if (isValid) {
      setProfile(newProfile);
    } else {
      setProfile(undefined);
    }
  };

  return (
    <ProfileInput
      titleText="Tell us about yourself"
      bodyText="This helps us personalize the intensity of your training plan."
      profile={profile || null}
      onProfileChange={handleProfileChange}
    />
  );
}
